import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { requestCreateProductSet } from "./createProductSet.request";

const useCreateProductSet = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchProductSets = useRefetchQuery(["product-sets"]);

  return useMutation({
    mutationFn: requestCreateProductSet,
    ...options,
    onSuccess: (...args) => {
      refetchProductSets();
      toast.success(t("Product set has been created successfully"));
      options?.onSuccess?.(...args);
    }
  });
};

export default useCreateProductSet;
